export default __webpack_public_path__ + "static/media/cocina.37a32d91.png";